import styled from 'styled-components';

export const LoginContainer = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${({ theme }) => theme.colors.secondary};
    align-content: center;
    justify-content: center;
    align-items: center;

    @media (max-width: 1024px) {
        flex-direction: column-reverse;
        width: 100%;
        height: 100%;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        background-color: ${({ theme }) => theme.colors.secondary};
        justify-content: space-between;
    }
`;
export const FormWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-self: center;
    margin: 0 auto;
    background-color: ${({ theme }) => theme.colors.secondary};
    @media (max-width: 1024px) {
        border: none;
        padding: 0;
        margin: 0;
    }
`;
export const Form = styled.form`
    display: flex;
    flex-direction: column;
    align-items: center;
`;
export const InputContainer = styled.div`
    width: 100%;
    max-width: 345px;
    margin-bottom: 10px;
    @media (max-width: 1024px) {
        margin-bottom: 15px;
        max-width: 100%;
    }
`;
export const CheckboxContainer = styled.div`
    display: flex;
    align-items: center;
    width: ${({ width }) => (width ? width : '280px')};
    margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '0')};

    a {
        margin-left: auto;
    }
`;
export const Checkbox = styled.input`
    min-width: 20px;
    min-height: 20px;
    background-color: ${({ theme }) => theme.colors.secondary};
    border-radius: 50%;
    vertical-align: middle;
    border: ${({ theme }) => `1px solid ${theme.colors.secondaryVariant}`};
    -webkit-appearance: none;
    outline: none;
    cursor: pointer;
    margin: 0 6px 0 0;

    :checked {
        background-image: url('/checkbox.jpg');
        background-size: cover;
    }
`;
export const CheckboxLabel = styled.label`
    margin: 10px 0 10px 0;
    color: ${({ theme, error }) => error && theme.colors.error};
    display: flex;
    align-items: center;

    * {
        color: ${({ theme, error }) => error && theme.colors.error};
    }
`;
export const BackIconWrapper = styled.div`
    display: flex;
    align-self: start;
    background: transparent;
    border: none;
    cursor: pointer;
    top: 30px;
    left: ${({ right }) => (right ? '85%' : 0)};
    z-index: 9;
    position: absolute;
    width: 100%;
    padding: 20px;
`;
export const ForgotPasswordWrapper = styled.div`
    padding-top: 140px;
    display: flex;
    flex-direction: column;
    width: 64%;
    margin-left: auto;
    margin-right: auto;

    @media (max-width: 1024px) {
        align-items: center;
        width: 100%;
        padding: 86px 40px 0;
    }
`;

export const ResetPasswordInputWrapper = styled.div`
    margin-top: 10px;

    label {
        margin-top: 0;
    }
`;
